import React, { useState , useEffect} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import * as R from 'ramda'

const useStyles = makeStyles(theme => ({
    root: {
        //width: '650vh',
        height: '100%',
        position: 'relative'
    },
    grid: {
        zIndex:9999,
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left:0,
    },
    row: {
        zIndex:9999,
        display: 'flex',
        flexDirection: 'row',
    },
    child: {
        position: 'absolute',
        top: 0,
        left:0,
    }
}))


const FormGrid = ({children,countrow,countcol,init}) => {
    const classes = useStyles()
    const [paint,Setpaint] = useState(init)      
    const ShowRow = ({ ind }) => {
        let nstyle = { width: `calc(100%/${countcol})` }
        return (<div className={classes.row}>
                 {[...Array(countcol)].map((_, i) => {
                     const mark = paint.filter(f=>f.r==ind&&f.c==i).length > 0
                     return (<div style={!mark ? nstyle : { ...nstyle, backgroundColor: '#efe' }}
                           title={`Ячейка (${ind},${i})`}
                           onClick={()=>Setpaint([...paint,{r:ind,c:i}])}
                     >&nbsp;</div>)
                   }
                  )}
                </div>)
    }
    return (
        <div className={classes.root}>
           <div className={classes.grid}>
                {[...Array(countrow)].map((_,i) =>
                  <ShowRow key={i} ind={i} /> 
                )}
            </div> 
            <div className={classes.child}>{children}</div>
        </div>
       );
 }

 FormGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default FormGrid;
